var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentStatusSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    style: {
      enableBackground: "new 0 0 82 82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#D4BC87;stroke-width:1.5;}\n\t.st1{fill:none;stroke:#D4BC87;stroke-width:1.5;stroke-linecap:round;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 41,
    cy: 41,
    r: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,42.8l8.8,8.8L55,32.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusSuccess);
export default __webpack_public_path__ + "static/media/payment-status-success.2c24434b3b4c35e771f1ce77143e2ec9.svg";
export { ForwardRef as ReactComponent };